import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import BackButton from "../button/general/Back";

export default function FormPageHeading({
    title,
    description,
    Icon,
    route,
}: {
    title: string;
    description: string;
    route?: string;
    Icon: LucideIcon;
}) {
    return (
        <CardHeader className="relative flex flex-col items-start border-b bg-slate-50/50 dark:bg-slate-800/50">
            <BackButton route={route} />

            <div className="flex items-center gap-3">
                <div className="rounded-lg bg-primary/10 p-4">
                    <Icon className="h-6 w-6 text-primary" />
                </div>
                <div>
                    <CardTitle className="text-3xl font-bold tracking-tight">
                        {title}
                    </CardTitle>
                    <CardDescription className="mt-1 text-sm text-muted-foreground">
                        {description}
                    </CardDescription>
                </div>
            </div>
        </CardHeader>
    );
}
